// Used in clear-assign-cart.helper.ts, resource-container.component.ts, teacher.component.ts, assign-review-component.ts,
// assignables-list.component.ts, side-nav.component.ts, standards-nav.component.ts

import { EditionId, SubjectId } from "@carnegie-learning/common-types";
import { Asset, Bundle, CustomActivity, Perform } from "@carnegie-learning/cure-types";
import { createAction, props } from "@ngrx/store"; // Action is an interface of type string

// Set Assign Cart Tab
export const setAssignCartTabOpen = createAction(
    "[Cart] Set Assign Cart Tab Open",
    props<{ payload: boolean }>()
);

// Set Assign Cart
export const setAssignCartOpen = createAction(
    "[Cart] Set Assign Cart Open",
    props<{ payload: boolean }>()
);

// Set Creating Bundle
export const setCreatingLesson = createAction(
    "[Cart] Set Creating Lesson",
    props<{ payload: boolean }>()
);

// Set Editing Bundle
export const setEditingLesson = createAction(
    "[Cart] Set Editing Lesson",
    props<{ payload: boolean }>()
);

// Set Creating Activity
export const setCreatingActivity = createAction(
    "[Cart] Set Creating Activity",
    props<{ payload: boolean }>()
);

// Set Editing Activity
export const setEditingActivity = createAction(
    "[Cart] Set Editing Activity",
    props<{ payload: boolean }>()
);

// Set Contains Composite assignable
export const setContainsComposite = createAction(
    "[Cart] Set Contains Compsite",
    props<{ payload: boolean }>()
);

// Set Bundle Form Data
export const setLessonFormData = createAction(
    "[Cart] Set Lesson Form Data",
    props<{ payload: Bundle | null }>()
);

// Set Bundle Form Validity
export const setLessonFormValidity = createAction(
    "[Cart] Set Lesson Form Validity",
    props<{ payload: boolean }>()
);

// Set Custom Activity Form Data
export const setCustomActivityFormData = createAction(
    "[Cart] Set Custom Activity Form Data",
    props<{ payload: CustomActivity | null }>()
);

// Set Perform Activity Form Data
export const setPerformActivityFormData = createAction(
    "[Cart] Set Perform Activity Form Data",
    props<{ payload: Perform | null }>()
);

// Set Activity Form Validity
export const setActivityFormValidity = createAction(
    "[Cart] Set Activity Form Validity",
    props<{ payload: boolean }>()
);

// Set Selected Program Subject Id
export const setProgramSubjectId = createAction(
    "[Cart] Set Program Subject Id",
    props<{ payload: SubjectId }>()
);
export const setProgramEditionId = createAction(
    "[Cart] Set Program Edition Id",
    props<{ payload: EditionId }>()
);

export const checkAssetInUse = createAction(
    "[Cart] Check Asset In Use",
    props<{ asset: Asset }>()
);

export const checkAssetInUseSuccess = createAction(
    "[Cart] Check Asset In Use Success",
    props<{ bool: boolean }>()
);

export const checkAssetInUseFail = createAction(
    "[Cart] Check Asset In Use Fail",
    props<{ payload: any }>()
);
